/*
 * Authors: mariushirjanu, Koen
 * Created: 31/01/2017
 * Created: 09/01/2024
 */
import * as _ from 'underscore';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';
import { ButtonAddonComponent } from '../formly/addons/button-addon.component';
import { AfterViewChecked, ChangeDetectorRef } from '@angular/core';

interface ISearchInputModel {
  query:string;
}

@Component({
  selector: 'search-input',
  template: `
    <formly [form]="form" [fields]="fields" [model]="model" [noValidate]="true"></formly>
  `
})
export class SearchInputComponent implements OnInit, AfterViewInit, AfterViewChecked, OnChanges {
  @Input() public query:string;
  @Input() public placeHolder:string;
  @Input() public searching:boolean;
  @Input() public searchTextRequired:boolean;
  @Output() public onSearch:EventEmitter<string> = new EventEmitter();

  public form:UntypedFormGroup = new UntypedFormGroup({});
  public fields:IExtraFieldConfigurationObject[];
  public model:ISearchInputModel = <any>{};
  private queryField:IExtraFieldConfigurationObject;

  constructor(
    private formlyService:GaFormlyService,
    private readonly changeDetectorRef:ChangeDetectorRef
  ) {
    this.fields = this.createFields();
  }

  public ngOnInit(){
    this.queryField.templateOptions.placeholder = this.placeHolder;
  }

  public ngAfterViewInit():void {
    // initial form state can be updated here and not in ngOnInit as the field is not yet fully initialised
    this.queryField.formControl.patchValue(this.query);
  }

  public ngAfterViewChecked():void {
    // force change detection because form control attributes value might change after initial detect change
    this.changeDetectorRef.detectChanges();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.query) {
      this.query = _.clone(changes.query.currentValue);
      this.queryField?.formControl?.patchValue(this.query);
    }

    if (changes.searching) {
      this.searching = _.clone(changes.searching.currentValue);
    }
  }

  private createFields():IExtraFieldConfigurationObject[] {
    return [
      this.queryField = this.formlyService.anInput('query', 'GA.GENERAL.SEARCH_TEXT')
        .withRequired(this.searchTextRequired)
        .withInputType('search')
        .withPlaceholder(this.placeHolder || 'GA.GENERAL.SEARCH_TEXT')
        .withExtraOptions({
          templateOptions: {
            inputFocus: true
          }
        })
        .withAddOnButton({
          component: ButtonAddonComponent,
          inputs: {
            label: 'GA.BUTTONS.SEARCH',
            icon: 'fa-search',
            disable: () => !this.model.query,
            busy: () => this.searching
          },
          outputs: {
            onClick: () => {
              this.onSearch.emit(this.model.query);
            }
          }
        })
        .withoutWrapper()
        .build()
    ];
  }
}
